// extracted by mini-css-extract-plugin
export default {"linkLike":"EmailLink_linkLike__Qb4Yy"};